import React from 'react';
import PropTypes from 'prop-types';
import { SlickTemplatePrev } from '../../../shared/component/svgIcon';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function LeftArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      style={{
        ...style,
        position: 'absolute',
        width: '60px',
        height: '50px',
        top: '50px',
        left: '-40px',
      }}
      onClick={onClick}
      role="none"
    >
      <span style={{ width: '100%', height: '100%', margin: '15px' }}>
        <SlickTemplatePrev />
      </span>
    </div>
  );
}
LeftArrow.propTypes = {
  style: PropTypes.objectOf().isRequired,
  onClick: PropTypes.objectOf().isRequired,
};
export default LeftArrow;
